import { render, staticRenderFns } from "./SupplierStatus.vue?vue&type=template&id=2bd650d4"
import script from "./SupplierStatus.vue?vue&type=script&lang=js"
export * from "./SupplierStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports